import { render, staticRenderFns } from "./PollRankedEditorBody.vue?vue&type=template&id=042cb495&scoped=true"
import script from "./PollRankedEditorBody.vue?vue&type=script&lang=js"
export * from "./PollRankedEditorBody.vue?vue&type=script&lang=js"
import style0 from "./PollRankedEditorBody.vue?vue&type=style&index=0&id=042cb495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042cb495",
  null
  
)

export default component.exports